import { Injectable } from '@angular/core';

import { Client } from '@stomp/stompjs';
import SockJS from 'sockjs-client';
import { BehaviorSubject } from 'rxjs';
import { Greeting, HelloMessage } from './debug.model';
import { AppService } from '@app/core/services/app.service';

@Injectable({
  providedIn: 'root',
})
export class WebSocketService {
  private client: Client;

  public connected: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public greeting: BehaviorSubject<Greeting> = new BehaviorSubject(null);

  constructor(private appService: AppService) {}

  connect() {
    this.client = new Client({
      webSocketFactory: () => new SockJS(this.appService.get().webSocket.url),
      reconnectDelay: 3000,
    });

    this.client.onConnect = () => {
      this.connected.next(true);

      this.client.subscribe('/topic/greetings', (event) => {
        const greeting = this.parseEvent<Greeting>(event);
        this.greeting.next(greeting);
      });
    };

    this.client.onDisconnect = () => {
      this.connected.next(false);
    };

    this.client.activate();
  }

  disconnect() {
    this.client.deactivate();
  }

  send(message: HelloMessage) {
    this.client.publish({
      destination: '/dwo/hello',
      body: JSON.stringify(message),
    });
  }

  private parseEvent<T>(event: any): T {
    return JSON.parse(event.body) as T;
  }
}
